import type { WebinarLanguage } from '@/features/webinar/types';
import { getAppLanguageFromApi } from '@/i18n/languages';

/** Langue i18n des textes vus par le spectateur : celle du webinaire, français par défaut. */
export function toWebinarLng(language: WebinarLanguage | null | undefined): string {
  return getAppLanguageFromApi(language).code;
}
